import { ViewComponentKey as GlobalViewComponentKey } from '@typescript-kit/view';

export class ViewComponentKey extends GlobalViewComponentKey {
  static readonly TEMPLATE = 'kit-view/component/template';
}
